import type { CartInstallationDetailsDTO } from '@t/api.types';
import type { HardwareDelivery, InstallationFormValues } from '@t/checkout.types';

export const mapCartInstallationToFormValues = (
  details: CartInstallationDetailsDTO | null | undefined
): InstallationFormValues | null => {
  if (!details?.startDateTime || !details?.endDateTime) return null;

  const installationMethod = details.installationMethod ?? 'TECHNICIAN';
  const isSelf = installationMethod === 'SELF';
  const hardwareDelivery: HardwareDelivery | undefined = isSelf
    ? details.deliveryMethod === 'PICKUP'
      ? 'PICKUP'
      : 'DROPOFF'
    : undefined;

  const isSelfDropoff = isSelf && hardwareDelivery === 'DROPOFF';
  const notes = details.notes ?? '';

  return {
    installationMethod,
    hardwareDelivery,
    deliveryInstructions: isSelfDropoff ? notes : '',
    specialInstructions: isSelfDropoff ? '' : notes,
    selectedSlotId: details.startDateTime,
    selectedDate: new Date(details.startDateTime),
    selectedTimeSlot: { startTime: details.startDateTime, endTime: details.endDateTime },
  };
};
